import dynamic from "next/dynamic";

export const ServicesCarousel = dynamic(() => import("./component"));
